import React from 'react'
import Browser from '../browser'

const BrowserEn = () => {
    return <Browser languageCode="en" />
}

export default BrowserEn
